import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import React from 'react'

const GuideEInvoiceSuspensionRequest = ({ visible, setVisible }) => {
  return (
    <Dialog
      header="Đề nghị tạm ngừng sử dụng hóa đơn điện tử"
      visible={visible}
      onHide={() => setVisible(false)}
      style={{ width: '600px' }}
      footer={() => (
        <div className='flex justify-content-end'>
          <Button label="Đóng" onClick={() => setVisible(false)} className='p-button-sm' />
        </div>
      )}
    >
      <div>
        <p>
          <span className='font-bold'>Khai báo các thông tin đăng ký tạm ngừng sử dụng hóa đơn điện tử khi:</span>
          <br />
          Doanh nghiệp tạm ngừng kinh doanh, giải thể hoặc theo yêu cầu của CQT
        </p>
        <div style={{ background: '#E7F3FF' }} className='px-4 py-2 border-round-lg mb-2'>
          <p className='font-bold text-xl mb-2' style={{ fontStyle: 'italic' }}>
            Lưu ý:
          </p>
          <ul style={{ margin: 0, paddingLeft: '20px', fontStyle: 'italic' }}>
            <li className='mb-2'>
              Ngày bắt đầu và kết thúc ngừng sử dụng:
              <ul style={{ marginTop: '4px', paddingLeft: '20px', listStyleType: 'none' }}>
                <li>- Hai thông tin này bắt buộc nhập</li>
                <li>- Ngày bắt đầu ngừng sử dụng phải lớn hơn ngày lập tờ khai</li>
                <li>- Ngày bắt đầu ngừng sử dụng phải nhỏ hơn ngày kết thúc ngừng sử dụng</li>
              </ul>
            </li>
            <li className='mb-2'>
              Nếu sử dụng nhiều phần mềm phát hành hóa đơn điện tử khác nhau, đơn vị cần khai báo đầy đủ thông tin của các tổ chức cung cấp dịch vụ đăng ký tạm ngừng sử dụng.
            </li>
            <li>
              Chỉ khai báo số sê-ri chứng thư số nếu đơn vị cần đăng ký tạm ngừng sử dụng cho 1 hoặc nhiều chứng thư số cụ thể. Trường hợp đăng ký ngừng sử dụng cho toàn bộ chứng thư số thì có thể để trống thông tin này.
            </li>
          </ul>
        </div>
      </div>
    </Dialog>
  )
}

export default GuideEInvoiceSuspensionRequest